<div>
  <div class="flex-col">
    <div class="flex-row justify-start">
      <div class="flex-col mt-2.5">
        <div class="flex-row justify-between">
          <div class="mb-1.5 flex-col">
            <h1 class="mb-0 font-medium">
              {{appointment.dateTime | moment: 'dddd, MMMM Do YYYY @ hh:mm a'}}</h1>
            <div class="flex flex-row font-medium black">
              <div fxLayout="row">
                <span data-cy='service-code-span'>{{appointment?.embedded?.serviceCode ?
                  appointment?.embedded?.serviceCode.description : 'No service code indicated'}}</span>
              </div>
              <span class="primary-bullet ml-1 black">·</span>
              <span *ngIf="appointment.promisedDateTime; else noPromisedTime" data-cy='promised-time-span'>Promised by
                {{appointment.promisedDateTime | date: 'shortTime' }} on
                {{appointment.promisedDateTime | date: 'mediumDate' }}</span>
              <ng-template #noPromisedTime>
                <span>No promised time indicated</span>
              </ng-template>
            </div>
          </div>
          <div>

          </div>


          <mat-divider class="mb-2"></mat-divider>


          <div class="flex-col">
            <div class="ml-1 flex-col">
              <div class="flex-row">
                <span class="primary-bullet">·</span>
                <span data-cy='service-advisor-info-span'>Service Advisor is
                  {{appointment.embedded?.serviceAdvisorAssociate?.firstName ?
                  appointment.embedded.serviceAdvisorAssociate.firstName : ''}}
                  {{ appointment.embedded?.serviceAdvisorAssociate?.lastName ?
                  appointment.embedded.serviceAdvisorAssociate.lastName: ''}}</span>
              </div>
              <div class="flex-row">
                <span class="primary-bullet">·</span>
                <span data-cy='ride-preference-info-span'>{{appointment?.embedded?.transportOption ? 'Ride preference is
                  ' + appointment.embedded.transportOption.name : 'No ride preference indicated' }}</span>
              </div>
            </div>

            <div class="flex-col justify-start">
              <div class="flex-row justify-between w-full mt-2">
                <h2 class="-mb-0 font-normal">
                  {{associate.firstName}}
                  {{associate.lastName}}</h2>
              </div>
              <div class="flex flex-row mb-1.5 -mt-1.5">
                <span class="text-base" *ngIf="vehicle" data-cy='vehicle-info-span'>{{vehicle.year}}
                  {{vehicle.make}}
                  {{vehicle.model}} (ID: {{vehicle.id}})</span>

                <!-- <span *ngIf="customerEquityValue" class="equity-label">In equity
                {{customerEquityValue | currency}}</span> -->
              </div>
              <div fxLayout="row" fxLayoutAlign="space-between center" class="w-full" data-cy='contact-info'>
                <div fxLayout="column" class="ml-1">
                  <div fxLayout="row"
                    *ngIf="associate && associate.messagePreferenceId != null; else noMessagePreference">
                    <span class="primary-bullet">·</span>
                    <ng-container [ngSwitch]="associate.messagePreferenceId">
                      <span *ngSwitchCase="1">Email preferred</span>
                      <span *ngSwitchCase="2">Text preferred</span>
                      <span *ngSwitchCase="3">IM preferred</span>
                      <span *ngSwitchCase="4">No message preference</span>
                    </ng-container>
                  </div>
                  <ng-template #noMessagePreference>
                    <div class="flex-row">
                      <span class="primary-bullet">·</span>
                      <span>No message preference</span>
                    </div>
                  </ng-template>
                  <div class="flex-row">
                    <span class="primary-bullet">·</span>
                    <span
                      *ngIf="associate &&associate.emailAddress && associate.emailAddress != ''; else noEmail">{{associate.emailAddress}}</span>
                    <ng-template #noEmail>No email on file</ng-template>
                  </div>
                  <div class="flex-row">
                    <span class="primary-bullet">·</span>
                    <div *ngIf="associate && associate.cellPhoneNumber != null; else checkHomePhone">
                      <span class="mr-1">Cell: </span><a
                        [href]="'tel:' + 'associate.cellPhoneNumber'">{{associate.cellPhoneNumber | phoneNumber}}</a>
                    </div>
                    <ng-template #checkHomePhone>
                      <div *ngIf="associate && associate.homePhoneNumber != null; else noPhone">
                        <span class="mr-1">Home: </span><a
                          [href]="'tel:' + 'associate.homePhoneNumber'">{{associate.homePhoneNumber | phoneNumber}}</a>
                      </div>
                      <ng-template #noPhone>No phone number on file</ng-template>
                    </ng-template>
                  </div>
                </div>
                <img *ngIf="vehicleImage; else noImageFound" class="h-15 w-auto" [src]="vehicleImage">
                <ng-template #noImageFound>
                  No vehicle image found.
                </ng-template>
              </div>
            </div>
          </div>

        </div>
      </div>